export enum RepaymentLevelType {
    Property = 0,
    Loan = 1,
}
